import { render, staticRenderFns } from "./Atelier.vue?vue&type=template&id=4c70fdc5&scoped=true"
import script from "./Atelier.vue?vue&type=script&lang=js"
export * from "./Atelier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70fdc5",
  null
  
)

export default component.exports